import ModalDeleteFilled from '../../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import { ModalEditComponentProps } from '../../../../../../baseComponents/ModalsLayouts/types'
import { useFetchText } from '../../../../../../utils/hooks/useFetchText'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'

interface ModalDeleteCsvOrderTemplateProps extends ModalEditComponentProps { }

const ModalDeleteCsvOrderTemplate: React.FC<ModalDeleteCsvOrderTemplateProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const { handleFetchText } = useFetchText({
        onSubmit,
        url: '/api/app/config/csvOrderTemplate/deleteCsvOrderTemplate',
        data: {
            id: allRowData?.id,
        }
    })
    return (
        <ModalDeleteFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchText} translations={{
            title: t('sureDeleteCsvOrderTemplate', '¿Seguro que quieres eliminar esta plantilla de exportación?'),
            subtitle: t('onceDeletedNotRecoverF', 'Una vez eliminada no podrás recuperarlo')
        }} />
    )
}

export default ModalDeleteCsvOrderTemplate